
    
     @if (showAddBehaviorData && selectedBehavior()) {
      <div class="supervisor-dialog-backdrop" (click)="hideAddData()"></div>
      <dialog class="supervisor-dialog" open>
        <app-add-behavior-data 
        [selectedPatientID]="selectedBehavior().PatientID!"
        [behavior]="selectedBehavior()" 
        [hideBehaviorSelector]="true"
          (close)="onCloseAddData($event)" />
      </dialog>
      } 
    <div class="filter-container mb-3">
      
      <div class="filter-row d-flex justify-content-end">
        <div class="filter-item">
          <button 
            pButton 
            type="button" 
            label="Add Data" 
            class="btn btn-primary" 
            (click)="addData()"
          ></button>
        </div>
      </div>
      <div class="filter-row">
        <div class="filter-item">
          <label for="startDate">Start Date</label>
          <input 
            id="startDate"
            type="date" 
            pInputText 
            [(ngModel)]="startDate" 
          />
        </div>
        <div class="filter-item">
          <label for="endDate">End Date</label>
          <input 
            id="endDate"
            type="date" 
            pInputText 
            [(ngModel)]="endDate" 
          />
        </div>
        <div class="filter-item">
          <label for="showDeleted">Show Deleted</label>
          <p-checkbox
            id="showDeleted"
            [(ngModel)]="showDeleted" 
            [binary]="true"
          />
        </div>
        <div class="filter-item">
          <button 
            pButton 
            type="button" 
            label="Filter" 
            class="btn btn-primary" 
            (click)="filterData()"
          ></button>
        </div>
      </div>
    </div>

    <p-table
      [attr.inert]="savingData ? '' : null"
      [loading]="savingData"
      [value]="behaviorsData"
      dataKey="ID"
      editMode="row"
      [rowHover]="true"
      (onRowExpand)="onBehaviorsRowExpand($event)"
      (onRowCollapse)="onBehaviorsRowCollapse($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          
          <th style="width: 2rem"></th>
          <th>Session</th>
          <th>Recorded Date</th>
          <th>Text Value</th>
          <th>Created By</th>
          <th>Modified By</th>
          <th>Modified Date</th>
          <th>Notes</th>
          <th style="width: 2rem"></th>
          <th style="width: 2rem"></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-sessionData
        let-editingSessionData="editing"
        let-expanded="expanded"
        let-sessionDataIndex="rowIndex"
      >
        <tr [pEditableRow]="sessionData" [class.deleted]="!!sessionData.DeletedDate">
          <td>
            <p-button
              type="button"
              pRipple
              [pRowToggler]="sessionData"
              [text]="true"
              [rounded]="true"
              [plain]="true"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            />
          </td>
          <td>
            @if (sessionData.SessionData) {
            Session on {{ sessionData.SessionData?.StartedDate | date : "MM/dd/yyyy HH:mm" }} - {{ sessionData.SessionData?.FinishedDate | date : "MM/dd/yyyy HH:mm" }}
              @if (sessionData.SessionData?.ServiceID) {
                <br>
                {{ sessionData.SessionData?.ServiceID ? 'Service: #' + sessionData.SessionData?.ServiceID : '' }} 
              }
            }
          </td>
          <td class="position-relative">
            @if (sessionData.DeletedDate) {
            <span class="badge-delete-rawdata">Deleted</span>
          } 
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="datetime-local"
                  step="1"
                  [(ngModel)]="sessionData.RecordedDate"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ sessionData.RecordedDate | date : "MM/dd/yyyy HH:mm" }}
              </ng-template>
            </p-cellEditor>
          </td>
          @if (behaviorIsDuration()) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    [showButtons]="true"
                    [min]="0"
                    [minFractionDigits]="1"
                    [maxFractionDigits]="2"
                    suffix=" minutes"
                    [(ngModel)]="behaviorDurationInMinutes"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ secondsToFormattedString(sessionData.IntValue ?? 0) }}
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (behaviorIsIntensity()) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-selectButton
                    [(ngModel)]="sessionData.IntValue"
                    [options]="intensityOptions()"
                    optionLabel="label"
                    optionValue="value"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ sessionData.IntValue }}
                </ng-template>
              </p-cellEditor>
            </td>
          } @else {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="sessionData.TextValue"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ sessionData.TextValue }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          
          <td class="position-relative">
            {{ getUserDisplayName(sessionData.UserID, sessionData.UserFullName) || 'N/A' }}
            @if (sessionData.ManuallyAddedDate) {
              <span 
                [pTooltip]="'Added Manually on ' + formatManuallyAddedDate(sessionData.ManuallyAddedDate) + (sessionData.ManuallyAddedByUser ? ' by ' + getUserNameFromViewModel(sessionData.ManuallyAddedByUser) : '')"
                tooltipPosition="right"
                style="margin-left: 5px; display: inline-block; background-color: #3b82f6; color: white; border-radius: 50%; width: 20px; height: 20px; text-align: center; line-height: 20px; font-size: 12px; font-weight: bold; cursor: help;"
              >M</span>
            }
          </td>
          <td>
            <!-- Modified By -->
            {{ sessionData.ModifiedByUser ? getUserNameFromViewModel(sessionData.ModifiedByUser) : 'N/A' }}
          </td>
          <td>
            <!-- Modified Date -->
            {{ sessionData.ModifiedDate ? (sessionData.ModifiedDate | date : "MM/dd/yyyy HH:mm") : 'N/A' }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="sessionData.Notes" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ sessionData.Notes }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                *ngIf="!editingSessionData"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                (click)="onRawDataEditInit(sessionData)"
                class="p-button-rounded p-button-text"
              ></button>
              <button
                *ngIf="editingSessionData"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="onRawDataEditSave(sessionData)"
                class="p-button-rounded p-button-text p-button-success mr-2"
              ></button>
              <button
                *ngIf="editingSessionData"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                  (click)="onRawDataEditCancel(sessionData)"
                class="p-button-rounded p-button-text p-button-danger"
              ></button>
            </div>
          </td>
          <td>
            <button
              *ngIf="!editingSessionData && !sessionData.DeletedDate"
              pButton
              pRipple
              title="Delete data"
              type="button"
              icon="pi pi-trash"
              (click)="onRawDataDelete(sessionData)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
            <button
              *ngIf="!editingSessionData && sessionData.DeletedDate"
              pButton
              pRipple
              title="Restore data"
              type="button"
              icon="pi pi-refresh"
              (click)="onRawDataRestore(sessionData)"
              class="p-button-rounded p-button-text p-button-success"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="expandedrow" let-sessionData>
        <tr [class.behavior-data-deleted]="!!sessionData.DeletedDate">
          <td colspan="10">
            <div class="p-3">
              <p-table
                [value]="[sessionData]"
                dataKey="ID"
                editMode="row"
                [rowHover]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Antecedents</th>
                    <th>Consequences</th>
                    <th>Location</th>
                    <th>Response</th>
                    <th>Severity</th>
                    <th style="width: 4rem"></th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-sessionData
                  let-editingSessionData="editing"
                  let-sessionDataIndex="rowIndex"
                >
                  <tr [pEditableRow]="sessionData">
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-multiSelect
                            appendTo="body"
                            [showClear]="true"
                            [options]="behaviorAntecedentsOptions()"
                            [(ngModel)]="
                              sessionData.PatientBehaviorAntecedentIDs
                            "
                            optionLabel="text"
                            optionValue="value"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getAntecedentsLabelsName(
                              sessionData.PatientBehaviorAntecedentIDs,
                              sessionData.PatientBehaviorAntecedentOther
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-multiSelect
                            appendTo="body"
                            [showClear]="true"
                            [options]="behaviorConsequencesOptions()"
                            [(ngModel)]="
                              sessionData.PatientBehaviorConsequenceIDs
                            "
                            optionLabel="text"
                            optionValue="value"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getConsequencesLabelsName(
                              sessionData.PatientBehaviorConsequenceIDs,
                              sessionData.PatientBehaviorConsequenceOther
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown
                            appendTo="body"
                            [options]="behaviorLocationsOptions()"
                            [(ngModel)]="sessionData.PatientBehaviorLocationID"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [showClear]="true"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getLocationName(
                              sessionData.PatientBehaviorLocationID
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown
                            appendTo="body"
                            [options]="behaviorResponsesOptions()"
                            [(ngModel)]="sessionData.PatientBehaviorResponseID"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [showClear]="true"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getResponseName(
                              sessionData.PatientBehaviorResponseID
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown
                            appendTo="body"
                            [options]="behaviorSeveritiesOptions()"
                            [(ngModel)]="sessionData.PatientBehaviorSeverityID"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [showClear]="true"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getSeverityName(
                              sessionData.PatientBehaviorSeverityID
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <div
                        class="flex align-items-center justify-content-center gap-2"
                      >
                        <button
                          *ngIf="!editingSessionData"
                          pButton
                          pRipple
                          type="button"
                          pInitEditableRow
                          icon="pi pi-pencil"
                          (click)="onRawDataEditInit(sessionData)"
                          class="p-button-rounded p-button-text"
                        ></button>
                        <button
                          *ngIf="editingSessionData"
                          pButton
                          pRipple
                          type="button"
                          pSaveEditableRow
                          icon="pi pi-check"
                          (click)="onRawDataEditSave(sessionData)"
                          class="p-button-rounded p-button-text p-button-success mr-2"
                        ></button>
                        <button
                          *ngIf="editingSessionData"
                          pButton
                          pRipple
                          type="button"
                          pCancelEditableRow
                          icon="pi pi-times"
                          (click)="onRawDataEditCancel(sessionData)"
                          class="p-button-rounded p-button-text p-button-danger"
                        ></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10">There are no Behavior entries.</td>
        </tr>
      </ng-template>
    </p-table>

    <button pButton type="button" label="Export to Excel" icon="pi pi-file-excel" (click)="exportExcel()"></button>
<app-loading-indicator *ngIf="isLoading"></app-loading-indicator>
